import React from 'react'

export default function StockOutListHeaderStyle({signed_in}) {
  let tb_buttons_display = null
  if (signed_in !== 'admin') tb_buttons_display = { stockout_fc: (signed_in.user_access.stockout_fc) ? 'block' : 'none' }
  else tb_buttons_display = { stockout_fc: 'block' }
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /*
        #refresh-list:hover .tooltip-text { left: 0%; }
        #refresh-list:hover .tooltip-text::after { left: 30%; }
        #settings:hover .tooltip-text { left: 20.8%; }
        #stock-out:hover .tooltip-text { left: 39.5%; }
        #batch-delete:hover .tooltip-text { left: 49%; }
        #batch-delete:hover .tooltip-text::after { left: 75%; }
        */

        /** Toolbar Button's **/
        #stock-out, #batch-delete { display: ${tb_buttons_display.stockout_fc}; }

        /* ROOT CONTAINER */
        #stockout-list-toolbar {
          display: flex;
          padding: 5px 0;
        }
        /* ROOT CONTAINER END */
      `}
      </style>
    </React.Fragment>
  )
}
